import { render, staticRenderFns } from "./seat.vue?vue&type=template&id=a071890a&scoped=true&"
import script from "./seat.vue?vue&type=script&lang=js&"
export * from "./seat.vue?vue&type=script&lang=js&"
import style0 from "./seat.vue?vue&type=style&index=0&id=a071890a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a071890a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a071890a')) {
      api.createRecord('a071890a', component.options)
    } else {
      api.reload('a071890a', component.options)
    }
    module.hot.accept("./seat.vue?vue&type=template&id=a071890a&scoped=true&", function () {
      api.rerender('a071890a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theaterManage/seat.vue"
export default component.exports